import * as yup from 'yup';

export const profSignUpvalidationSchema = yup.object({
    name: yup.string().required('Full Name is required'),
    email: yup.string().email('Invalid email address').required('Email is required'),
    password: yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter') // At least one uppercase
        .matches(/[0-9]/, 'Password must contain at least one number') // At least one number
        .matches(/[@$!%*?&]/, 'Password must contain at least one special character') // At least one special character
    ,
    confirm_password: yup.string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
    ss_number: yup.string().required('SSN is required'),
    about: yup.string().required('About Yourself is required'),
    profile: yup.mixed().required('Profile Picture is required'),
    certificate: yup.mixed()
        .required('Professional Certificate is required')
        .test('fileType', 'Only PDF, DOC, DOCX, TXT, and XLS files are allowed', (value) => {
            if (!value) return false;
            // Check if file type is valid (PDF, DOC, DOCX, TXT, XLS)
            return (
                value.type === 'application/pdf' ||
                value.type === 'application/msword' ||
                value.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                value.type === 'text/plain' ||
                value.type === 'application/vnd.ms-excel'
            );
        }),
    other: yup.mixed()
        .required('Supporting Document is required')
        .test('fileType', 'Only PDF, DOC, DOCX, TXT, and XLS files are allowed', (value) => {
            if (!value) return false;
            // Check if file type is valid (PDF, DOC, DOCX, TXT, XLS)
            return (
                value.type === 'application/pdf' ||
                value.type === 'application/msword' ||
                value.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                value.type === 'text/plain' ||
                value.type === 'application/vnd.ms-excel'
            );
        }),
});